import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OSAbstractionsSecurityNetworkingMultimedia = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Abstractions, Processes, Resources - Influence of Security, Networking, and Multimedia"
    videos={[]}
    takeaways={[
      { text: "These are mostly theory concepts—expect direct questions." }
    ]}
    questions={[
      "Elaborate in detail on aspects of security in an OS with respect to various threats.",
      "In a multiprogramming and time-sharing environment, several users share the system simultaneously. This situation can result in various security problems. How to ensure the degree of security in a time-shared machine similar to a dedicated machine? Explain your answer.",
      "The operating system provides tremendous services to the user. From the security perspective, which are the services to be considered? Justify your answer.",
      "Consider a multi-user and multi-programming operating system. Identify the various possible security threats to the resources. How does the OS ensure the security of the system resources?"
    ]}
    exampleVideos={[]}
  />
);
}

export default OSAbstractionsSecurityNetworkingMultimedia;
